import { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useUserStore } from '../store/useUserStore';
import 'bootstrap/dist/css/bootstrap.min.css';

import location_dark from '../assets/images/location_dark.png';
import heart_dark from '../assets/images/heart_dark.png';
import ruler_dark from '../assets/images/ruler_dark.png';
import wine_icon from '../assets/images/wine_icon.png';
import pet_icon from '../assets/images/pet_icon.png';
import education_icon from '../assets/images/education_icon.png';
import kids_red from '../assets/images/kids_red.png';
import globe_icon from '../assets/images/globe_icon.png';
import tshirt_icon from '../assets/images/tshirt_icon.png';
import weet_icon from '../assets/images/weet_icon.png';
import workout_icon from '../assets/images/workout_icon.png';
import edit_icon from '../assets/images/edit_icon.svg';
//import badge_check from '../assets/images/badge-check.svg';




import useAuthStore from '../store/useAuthStore';
import { useProfileUpdateStore } from '../store/useProfileUpdateStore';
import UpdateImages from '../components/UpdateProfile/UpdateImages';
import MyInformation from '../components/UpdateProfile/MyInformation';
import Bio from '../components/UpdateProfile/Bio';
import AboutMe from '../components/UpdateProfile/AboutMe';
import LifeStyle from '../components/UpdateProfile/LifeStyle';
import Personality from '../components/UpdateProfile/Personality';
import Extented from '../components/UpdateProfile/Extented';
import ProfileCarousel from '../components/ProfileCarousel';


type Photo = {
  picture: string;
  orignal_picture: string;
};

const UserProfile = () => {
    const navigate = useNavigate();
  const { user,  getUserDetails,genres, fetchGenres } = useUserStore();

  const {activeSection, setActiveSection } = useProfileUpdateStore();
  
  const authStore = useAuthStore.getState();
   const userId= authStore.user.id;


  const photoRef = useRef<HTMLDivElement | null>(null);
  const informationRef = useRef<HTMLDivElement | null>(null);
  const aboutMeRef = useRef<HTMLDivElement | null>(null);
  const lifeStyleRef = useRef<HTMLDivElement | null>(null);
  const personalityRef = useRef<HTMLDivElement | null>(null);
  const extentedRef = useRef<HTMLDivElement | null>(null);
  const interestRef = useRef<HTMLDivElement | null>(null);
  const [scrollToSection, setScrollToSection] = useState<string | null>(null);

  const [backgroundPhotos, setBackgroundPhotos] = useState<Photo[]>([]);

   const location = useLocation();

     const queryParams = new URLSearchParams(location.search);
     
      const param = queryParams.get('edit');

      useEffect(() => {
        if(param=='interest'){
             interestRef.current?.scrollIntoView({ behavior: "smooth" });
        }
           
     }, [param]); 

  useEffect(() => {
    if (scrollToSection === "photo") {
      photoRef.current?.scrollIntoView({ behavior: "smooth" });
      setScrollToSection(null); // Reset after scroll
    }
    if (scrollToSection === "information") {
      informationRef.current?.scrollIntoView({ behavior: "smooth" });
      setScrollToSection(null); // Reset after scroll
    }
    if (scrollToSection === "about_me") {
      aboutMeRef.current?.scrollIntoView({ behavior: "smooth" });
      setScrollToSection(null); // Reset after scroll
    }
    if (scrollToSection === "life_style") {
      lifeStyleRef.current?.scrollIntoView({ behavior: "smooth" });
      setScrollToSection(null); // Reset after scroll
    }
     if (scrollToSection === "personality") {
      personalityRef.current?.scrollIntoView({ behavior: "smooth" });
      setScrollToSection(null); // Reset after scroll
    }
    if (scrollToSection === "extented") {
      extentedRef.current?.scrollIntoView({ behavior: "smooth" });
      setScrollToSection(null); // Reset after scroll
    }
  }, [scrollToSection]);

   const scrollToBottomIfMobile = (offset:number) => {
  if (window.innerWidth <= 768) {
    setTimeout(() => {
      window.scrollTo({
        top: document.body.scrollHeight-offset,
        behavior: "smooth",
      });
    }, 100);
  }
};

  useEffect(() => {
    
    
    if (userId) {
      
      getUserDetails(parseInt(userId));
      fetchGenres();
    }
  }, [userId,getUserDetails]); 





  const getAnswerBySubtitle = (subTitle: any) => {
    const answer = user.user_answers.find((ans:any) => {
   //     console.log("Subtitle in answer:", ans.question); // Logging here
        return ans.question != null && ans.question.sub_title === subTitle;
      });
      const skipFormatting = ['Politics', 'Kids_People'];

     
      if (!answer) return skipFormatting.includes(subTitle)
            ? `Not specified`
            : `${subTitle
                .replace(/_/g, ' ')
                .replace(/\b\w/g, (c: string) => c.toUpperCase())}: Not specified`;
  
      let answerIds = answer.answer_id;

      // Handle stringified array like ["Affectionate", "Agreeable "]
      try {
        const parsed = JSON.parse(answerIds);

        if (Array.isArray(parsed)) {
          answerIds = parsed;
        }
      } catch (e:any) {
        console.log(e);
        
        // If parsing fails, it means it's not a JSON string, ignore the error
      }
    
      // If the answer is still a string, split by commas or trim spaces
      if (typeof answerIds === 'string') {
        answerIds = answerIds.includes(',')
          ? answerIds.split(',').map((item) => item.trim())
          : [answerIds.trim()];
      }
     
       // Ensure it's an array
        answerIds = Array.isArray(answerIds) ? answerIds : [answerIds];

       // console.log("Processed Answer IDs:", answerIds);
      //  console.log("Question Options:", answer.question.questions_options);

         // Check if question_options exist and match by option or ID
            const options = answer.question.questions_options
            ? answerIds
                .map((id: any) => {
                    const option = isNaN(id)
                    ? answer.question.questions_options.find((opt: any) => opt.option.trim() === id.trim()) // Match by option if not a number
                    : answer.question.questions_options.find((opt: any) => opt.id == id); // Match by ID if a number

                  // console.log(`Matching Option for ID/Option "${id}":`, option);
                    return option?.option;
                })
                .filter(Boolean)
            : answerIds;

           // console.log("Final Options:", options);

            return options.length > 0 ? options.join(', ') : 'Not specified';
    };

 

    const convertHeightToCm = (height:any) => {
        console.log('height',height);
        if(height==0){
            return 0;
        }
   
      height = height.replace(/’/g, "'").replace(/”/g, '"');
      const match = height.match(/(\d+)' (\d+)"/); // Extract feet and inches
      if (!match) return "Invalid height"; // Handle incorrect formats
    
      const feet = parseInt(match[1], 10);
      const inches = parseInt(match[2], 10);
      const cm = (feet * 30.48) + (inches * 2.54);
    
      return `${cm.toFixed(0)} cm`; // Return with 1 decimal place
    };



        // Get selected genres based on genre IDs in the user data
  const getSelectedGenres = () => {
    if (!user || !user.genres || !genres || !genres.length) return [];
    const genreIds = user.genres.split(',').map((id:any) => parseInt(id.trim()));
    return genres.filter((genre) => genreIds.includes(genre.id));
  };


 
const selectedGenres = getSelectedGenres();


// const userGenres = authStore.user?.genres?.split(",").map(Number); // Convert to an array of numbers
// let commonGenres:any =[];
// if(userGenres){
//  commonGenres = selectedGenres.filter(genre => 
//   userGenres.includes(genre.id) // Check if genre.id is in userGenres
// );
// }
useEffect(() => {
  if (user && Array.isArray(user.user_photos)) {
   // const filtered = user.user_photos.filter((photo: any) => photo.main_photo == 0);
    setBackgroundPhotos(user.user_photos);
    
    
  }
}, [user]);
  return (
    <section className="pt-4 pb-60 bg-light dating_profile_page">
    <div className="container">
        <div className="dp_profile_top_bredcrumb mb-4">
            <Link to="/dashboard" className="bck_btn"><i className="fa-solid fa-arrow-left"></i> Back </Link>
            <div className="dp_profile_drpdwn_wrpr">
                
            </div>
        </div>
        {user && (
        
        <div className="row" ref={photoRef}>
            <div className="col-lg-8 mb-3">
                <div className="card dating_profile_details_card p-4" >
                        <ProfileCarousel
                      backgroundPhotos={backgroundPhotos}
                      user={user}
                     
                    />

                      
                         
                    
                      <button className="btn btn_white_edit" onClick={() => {
                                                            setActiveSection("photos");
                                                            scrollToBottomIfMobile(2100);
                                                          }}>
                                <img src={edit_icon} alt="" className="img-fluid edit-icon" />
                      </button>
                     
                    
                    <div className="dp_details_profile_info pt-4 position-relative" ref={informationRef}>
                        <div className="row align-items-center">
                            <div className="col-xl-8">
                                <h2>{user.first_name}, {user.age} 
                                {/* {user.confirm ==1 ?   
                                <span className="badge badge-photo-verified ms-2">
                                    <img src={badge_check} alt="Verified" style={{ width: 16, height: 16, marginRight: 4 }} />
                                    Photo-verified
                                </span>
                                :''} */}
                                </h2>
                                <ul>
                                    <li><img src={location_dark} />{user.city}, {user.state} </li>
                                    <li><img src={heart_dark} />{getAnswerBySubtitle('Relationship_status')}</li>
                                    <li><img src={ruler_dark} />{user.height} ({convertHeightToCm(user.height ?? 0)})</li>
                                </ul>
                            </div>
                            <div className="col-xl-4">
                                 
                            
                            </div>
                        </div>
                        <div className="border-top pt-3 mt-3">
                            {/* <h5 className="font22 mb-3 pb-3 border-bottom">Bio</h5> */}
                                 <p>{user.know_about_you}</p>
                            {/* <p className="font18">“{user.profile_vibe}”</p> */}
                        </div>
                        {/* <div className="border-top pt-3 mt-3">
                            <h5 className="font18 mb-3">Common Genres</h5>
                            <div className="danger_badge_group">
                            
                              {commonGenres.length > 0 ? (
                                commonGenres.map((genre:any, index:any) => (
                                  <span key={index}>{genre.name}</span>
                                ))
                              ) : (
                                <span>No common genres</span>
                              )}
                                
                            </div>
                        </div> */}
                        <button className="btn btn-outline-primary btn_primary_edit" onClick={() => {setActiveSection("my_information");
                          scrollToBottomIfMobile(2200);
                        }}>
                                <img src={edit_icon} alt="" className="img-fluid edit-icon" />
                        </button>
                    </div>
                </div>
                {/* <div className="card mt-4 p-4">

                    <h5 className="font22 mb-3 pb-3 border-bottom">Bio</h5>
                    <p>{user.know_about_you}</p>
                    <button className="btn btn-outline-primary btn_primary_edit"  onClick={() => setActiveSection("bio")}>
                            <img src={edit_icon} alt="" className="img-fluid edit-icon" />
                        </button>
                </div> */}
                <div className="card mt-4 p-4 " ref={aboutMeRef} >
                <button className="btn btn-outline-primary btn_primary_edit" onClick={() => {
                        setActiveSection("about_me");
                        scrollToBottomIfMobile(1700);
                      // Scroll to top if desktop
                      if (window.innerWidth > 768) {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }
                    }}>
                            <img src={edit_icon} alt="" className="img-fluid edit-icon" />
                        </button>
                    <h5 className="font22 mb-4 pb-3 border-bottom">About</h5>
                    <div className="row g-4">
                  


                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box"><i className="fa-solid fa-venus"></i></div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Gender')}</p>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box"><i className="fa-regular fa-heart"></i></div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Relationship_status')}, intent: {getAnswerBySubtitle('Looking_Relationship')}, interested in {getAnswerBySubtitle('Seeking')}</p>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={education_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Education')}</p>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box"><i className="fa-solid fa-briefcase"></i></div>
                                <p className="mb-0 font18 ms-2 capitalize-first">{user.occupation ?? 'Occupation : Not specified'}</p>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box"><i className="fa-solid fa-book-open"></i></div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Religion')}</p>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={kids_red} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Have_kids')}</p>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={globe_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Ethnicity')}</p>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={tshirt_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Body_type')}</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="card mt-4 p-4 " ref={lifeStyleRef}>
                <button className="btn btn-outline-primary btn_primary_edit" onClick={() => {setActiveSection("life_style");
                    scrollToBottomIfMobile(1500);
                     // Scroll to top if desktop
                    if (window.innerWidth > 768) {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }
                    
                }}>
                            <img src={edit_icon} alt="" className="img-fluid edit-icon" />
                        </button>
                    <h5 className="font22 mb-4 pb-3 border-bottom" >Lifestyle</h5>
                    <div className="row g-4">
                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box"><i className="fa-solid fa-smoking"></i></div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Smokes')}</p>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={weet_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('420_firendly')}</p>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={wine_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Drinks')}</p>
                            </div>
                        </div>
                        <div className="col-md-7">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={workout_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Exercise')}</p>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="d-flex align-items-center font500">
                                <div className="danger_icon_box">
                                    <img src={pet_icon} alt="" />
                                </div>
                                <p className="mb-0 font18 ms-2">{getAnswerBySubtitle('Have_pets')}</p>
                            </div>
                        </div>


                    </div>
                </div>
                <div className="card mt-4 p-4"  ref={personalityRef}>
                <button className="btn btn-outline-primary btn_primary_edit" onClick={() => 
                {
                    setActiveSection("personality");
                     scrollToBottomIfMobile(4500);
                     // Scroll to top if desktop
                    if (window.innerWidth > 768) {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }
                 }}>
                            <img src={edit_icon} alt="" className="img-fluid edit-icon" />
                        </button>
                    <h5 className="font22 mb-4 pb-3 border-bottom">Personality Type</h5>
                    <div className="danger_outline_badge_group">
                        {Array.isArray(getAnswerBySubtitle('Personality'))
                        ? getAnswerBySubtitle('Personality').map((trait: string, index: number) => (
                            <span key={index}>
                            {trait}
                            </span>
                        ))
                        : getAnswerBySubtitle('Personality').split(',').map((trait: string, index: number) => (
                          <span key={index}>
                          {trait}
                          </span>
                      ))
                     }
                     
                    </div>


                </div>
                <div className="card mt-4 p-4" ref={extentedRef} >
                <button className="btn btn-outline-primary btn_primary_edit" onClick={() => {setActiveSection("extented");  scrollToBottomIfMobile(1900);
                     // Scroll to top if desktop
                    if (window.innerWidth > 768) {
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}}>
                            <img src={edit_icon} alt="" className="img-fluid edit-icon" />
                        </button>
                    <h5 className="font22 mb-4 pb-3 border-bottom">Extended Profile</h5>
                    <div className="danger_outline_badge_group">
            
                        <span>{getAnswerBySubtitle('Horoscope')}</span>
                        <span>Looking for match between {user.looking_min_age}-{user.looking_max_age}</span>
                        <span>Political affiliation is {getAnswerBySubtitle('Politics')}</span>
                        <span>Will date people that have Kid? - {getAnswerBySubtitle('Kids_People')}</span>
                    </div>
                </div>
                <div className="card mt-4 p-4" ref={interestRef}>
                <button className="btn btn-outline-primary btn_primary_edit" onClick={() => navigate("/genres-edit")}>
                            <img src={edit_icon} alt="" className="img-fluid edit-icon" />
                        </button>
                    <h5 className="font22 mb-4 pb-3 border-bottom">Interests Feature</h5>
                    <div className="danger_outline_badge_group">
                    {selectedGenres.length > 0 ? (
                      selectedGenres.map((genre, index) => (
                        <span key={index} >
                          {genre.name}
                        </span>
                      ))
                    ) : (
                      <span>No interests selected</span>
                    )}
                       
                    </div>
                </div>
            </div>
            <div className="col-lg-4">
                
                    {activeSection === 'photos' && (
                    <UpdateImages onSaveSuccess={() => setScrollToSection("photo")} />
                    )}
                    {activeSection === 'my_information' && (
                    <MyInformation onSaveSuccess={() => setScrollToSection("information")} />
                    )}

                    {activeSection === 'bio' && (
                    <Bio />
                    )}

                    {activeSection === 'about_me' && (
                    <AboutMe onSaveSuccess={() => setScrollToSection("about_me")} />
                    )}
                     {activeSection === 'life_style' && (
                    <LifeStyle onSaveSuccess={() => setScrollToSection("life_style")} />
                    )}
                    {activeSection === 'personality' && (
                    <Personality onSaveSuccess={() => setScrollToSection("personality")} />
                    )}
                    {activeSection === 'extented' && (
                    <Extented onSaveSuccess={() => setScrollToSection("extented")} />
                    )}

                    {activeSection === null && (
                    <div className='border1 rounded demodix'></div>
                    )}



           
            </div>
        </div>
      )}
    </div>
 
</section>

  );
};

export default UserProfile;
